document.addEventListener("DOMContentLoaded", function () {

  const buttons = document.querySelectorAll(".wishlist-btn");

  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  function updateWishlistCount(){

    const wishlist = getWishlist();

    const bubble =
      document.querySelector(".wishlist-count-bubble");

    if(!bubble) return;

    if(wishlist.length > 0){

      bubble.style.display = "flex";

      bubble.querySelector("span").innerText =
        wishlist.length;

    } else {

      bubble.style.display = "none";

    }

  }

  function updateButtons() {

    const wishlist = getWishlist();

    buttons.forEach(button => {

      const handle = button.dataset.productHandle;
      const text = button.querySelector(".wishlist-text");

      if (wishlist.includes(handle)) {

        button.classList.add("is-active");

        if (text) {
          text.innerText = text.dataset.removeText;
        }

      } else {

        button.classList.remove("is-active");

        if (text) {
          text.innerText = text.dataset.addText;
        }

      }

    });

    updateWishlistCount();

  }

  buttons.forEach(button => {

    button.addEventListener("click", function (e) {

      e.preventDefault();

      const handle = this.dataset.productHandle;

      let wishlist = getWishlist();

      if (wishlist.includes(handle)) {

        wishlist = wishlist.filter(item => item !== handle);

      } else {

        wishlist.push(handle);

      }

      saveWishlist(wishlist);

      updateButtons();

    });

  });

  updateButtons();

});